import styled from '@emotion/styled'

export const FormModuleWrapper = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 504px;
  margin: 0 auto;
`
